export const breakLongJobTitle = (
  title: string,
): { firstPartTitle: string; secondPartTitle: string } => {
  if (title.length > 25) {
    let middle = Math.floor(title.length / 2);
    const before = title.lastIndexOf(' ', middle);
    const after = title.indexOf(' ', middle + 1);

    if (middle - before < after - middle) {
      middle = before;
    } else {
      middle = after;
    }

    return {
      firstPartTitle: title.substr(0, middle),
      secondPartTitle: title.substr(middle + 1),
    };
  }
  return {
    firstPartTitle: title,
    secondPartTitle: '',
  };
};
